export const walkingDirection = state => state.getIn(['navigation', 'walkingDirection'])
export const entryPoint = state => state.getIn(['navigation', 'entryPoint'])
export const orientation = state => state.getIn(['navigation', 'orientation'])
